import { render, staticRenderFns } from "./lesson-detail.vue?vue&type=template&id=d37353f8&scoped=true&"
import script from "./lesson-detail.vue?vue&type=script&lang=js&"
export * from "./lesson-detail.vue?vue&type=script&lang=js&"
import style0 from "./lesson-detail.vue?vue&type=style&index=0&id=d37353f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37353f8",
  null
  
)

export default component.exports